export const EmailRegular = () => {
    return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
};

export const PassWordRegular = () => {
    return /^[0-9A-Za-z_\W]{4,16}$/;
};
